import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-8 w-full min-w-0 px-3 py-1.5 file:text-foreground dark:bg-input/30 border border-input rounded-md bg-transparent shadow-sm transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "text-sm leading-normal font-regular text-foreground placeholder:text-muted-foreground",
        "focus-visible:border-input focus-visible:ring-ring focus-visible:ring-1 ",
        "aria-invalid:ring-destructive dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive/40",
        className
      )}
      {...props}
    />
  );
}

export { Input };
